import type { RibbonControlProps } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import { type MailRibbonControlId, type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import type { RibbonControlId } from 'owa-ribbon-ids';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { logUsage } from 'owa-analytics';
import { debugErrorThatWillShowErrorPopupOnly } from 'owa-trace';
import { getRibbonMailboxInfo } from 'owa-mail-ribbon-utils/lib/getRibbonMailboxInfo';
import {
    getAddToFavoritesControl,
    getFolderPaneControl,
    getNewFolderControl,
    getNewSearchFolderControl,
} from '../../sharedControls/readSharedControlDefinitions';

export const getMLRFolderTabControlDefinition: (
    controlId: RibbonControlId,
    _tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
) => RibbonControlProps | undefined = owaComputedFn(function getMLRFolderTabControlDefinition(
    controlId: RibbonControlId,
    _tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
): RibbonControlProps | undefined {
    switch (controlId) {
        case 767:
            return getAddToFavoritesControl(props);
        case 768:
            return getNewFolderControl(false /* isSLR */, props);
        case 769:
            return getNewSearchFolderControl(false /* isSLR */, props);
        case 647:
            return getFolderPaneControl(false /* isSLR */, 17, props);
        default:
            const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);

            debugErrorThatWillShowErrorPopupOnly(
                'getMLRFolderTabControlDefinition UnknownControl: ' + controlId
            );

            logUsage('MLRFolderTabControlDefinitionUnknownControl', mailboxInfo, {
                controlId,
                stack: new Error('MLRFolderTabControlDefinitionUnknownControl').stack,
            });
            return undefined;
    }
});
